/* -------------------------------------------------------------------------- *
 * Anchor Link Component *
 * -------------------------------------------------------------------------- *
 */

const anchorLink = document.getElementsByClassName('js-anchorLink');

function animateToAnchor(e) {
    e.preventDefault();

    document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth',
    });
}

const AnchorLink = {
    init() {
        Array.from(anchorLink).forEach((el) => {
            el.addEventListener('click', animateToAnchor);
        });
    },
};

export default AnchorLink;
